import React, { useContext } from "react";

export const IsStickyContext = React.createContext(false);

export const useIsSticky = (): boolean => {
  return useContext(IsStickyContext);
};
